import React from 'react';
export function UrgencyBar() {
  return <div className="fixed top-0 left-0 right-0 bg-red-600 text-white text-center py-1.5 px-4 z-50 font-bold text-xs md:text-sm shadow-md" data-id="element-321">
      🔥 Acceso inmediato + Contenido descargable mes a mes de 1° a 6° grado
    </div>;
}